// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"51388f52","454":"d515babb","541":"09e41584","942":"46e4c56e","972":"83cecf83","995":"54fc14a1"}[chunkId] + ".chunk.js";
};